import { render, staticRenderFns } from "./unlicensedEntry.vue?vue&type=template&id=1c561784&scoped=true&"
import script from "./unlicensedEntry.vue?vue&type=script&lang=js&"
export * from "./unlicensedEntry.vue?vue&type=script&lang=js&"
import style0 from "./unlicensedEntry.vue?vue&type=style&index=0&id=1c561784&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c561784",
  null
  
)

component.options.__file = "unlicensedEntry.vue"
export default component.exports